<template>
  <b-row>
    <b-col cols="12">
      <order-numbers-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import OrderNumbersTable from './OrderNumbersTable.vue'

export default {
  components: {
    BRow,
    BCol,

    OrderNumbersTable
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>